/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyProfileDto } from './companyProfileDto';
import { ContactPersonDto } from './contactPersonDto';


export interface RegisterCompanyDto { 
    /**
     * Decentralized Identifier (DID)
     */
    did: string;
    /**
     * Company profile information
     */
    companyProfile: CompanyProfileDto;
    /**
     * DID of the entity that invited this company
     */
    invitedBy?: string;
    /**
     * Array of contact persons
     */
    contactPersons?: Array<ContactPersonDto>;
    /**
     * Credential types being requested. All 5 GBA credential types are supported: GBAFacilityReportIssuer, GBAVerifiedCompany, GBAApprovedVerifierCredential, GBAApprovedCertifierCredential, GBAApprovedCarbonCalculationPartnerCredential.
     */
    requestedCredentialTypes: Array<RegisterCompanyDto.RequestedCredentialTypesEnum>;
    /**
     * Verifiable Presentation containing existing identity credentials (e.g., vLEI from GLEIF) for companies with their own IT infrastructure. If valid (GBAVerifiedCompany from trusted GBA issuer, matching subject DID), triggers auto-approval. Supports both VCDM 2.0 (validFrom/validUntil) and 1.1 (issuanceDate/expirationDate) for backward compatibility.
     */
    existingIdentityPresentation?: object;
}
export namespace RegisterCompanyDto {
    export const RequestedCredentialTypesEnum = {
        GbaFacilityReportIssuer: 'GBAFacilityReportIssuer',
        GbaVerifiedCompany: 'GBAVerifiedCompany',
        GbaApprovedVerifierCredential: 'GBAApprovedVerifierCredential',
        GbaApprovedCertifierCredential: 'GBAApprovedCertifierCredential',
        GbaApprovedCarbonCalculationPartnerCredential: 'GBAApprovedCarbonCalculationPartnerCredential'
    } as const;
    export type RequestedCredentialTypesEnum = typeof RequestedCredentialTypesEnum[keyof typeof RequestedCredentialTypesEnum];
}


